import React, { PureComponent } from 'react';
import { Flex, Box } from 'rebass';
import { connect } from 'unistore/react';
import ReactSelect from 'react-select';

import Actions from '~/state/Actions';
import { groupedOptionsSelector, compareOptionSelector } from '~/state/Selectors';

const overwriteFontSize = provided => ({
  ...provided,
  fontSize: '14px'
});

const ReactSelectStyles = {
  input: overwriteFontSize,
  placeholder: overwriteFontSize,
  singleValue: overwriteFontSize,
  menu: overwriteFontSize,
  control: provided => ({
    ...provided,
    backgroundColor: '#fff'
  })
};

class Controls extends PureComponent {
  render() {
    const {
      data,
      overallKey,
      setTooltipVisibility,
      setOverallKey,
      setCompareKey,
      options,
      compareValue
    } = this.props;

    if (!data) {
      return null;
    }

    return (
      <Flex pb={2} my={2} mx={-2} justifyContent="space-between">
        <Box width={1 / 2} px={2} css={{ maxWidth: 250 }}>
          <ReactSelect
            options={options}
            isSearchable={false}
            styles={ReactSelectStyles}
            defaultValue={{ value: overallKey, label: overallKey.replace(/^.*\./g, '') }}
            onChange={option => setOverallKey(option.value)}
            onMenuOpen={() => setTooltipVisibility(false)}
          />
        </Box>
        <Box width={1 / 2} px={2} css={{ maxWidth: 250 }}>
          <ReactSelect
            options={options}
            isSearchable={false}
            styles={ReactSelectStyles}
            value={compareValue}
            onChange={option => setCompareKey(option.value)}
            onMenuOpen={() => setTooltipVisibility(false)}
          />
        </Box>
      </Flex>
    );
  }
}

export default connect(state => ({
  data: state.distributionData,
  overallKey: state.overallKey,
  compareKey: state.compareKey,
  options: groupedOptionsSelector(state),
  compareValue: compareOptionSelector(state)
}), Actions)(Controls);
